import MiHistory from './history';
import { install } from '../../utils/install';
export default install(MiHistory);
